import { Link } from "react-router-dom";
import { Landmark, Instagram, Facebook, Twitter } from "lucide-react";
import { NAV, BRAND } from "@/data/site";
import { BookButton } from "@/components/common/BookButton";

export const Footer = () => (
  <footer className="mt-8 bg-charcoal text-white" data-testid="footer">
    <div className="container-wide py-16 md:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
        <div className="max-w-sm">
          <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gold text-charcoal">
              <Landmark size={20} strokeWidth={1.75} />
            </span>
            <span className="font-serif text-xl font-semibold">Roman Colosseum Tickets</span>
          </Link>
          <p className="mt-5 text-[15px] font-light leading-relaxed text-white/60">
            {BRAND.tagline} We compare trusted partners so you can choose the right Colosseum
            experience with total confidence.
          </p>
          <div className="mt-6">
            <BookButton label="Browse all tickets" testId="footer-book" />
          </div>
          <div className="mt-7 flex gap-3">
            {[Instagram, Facebook, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="Social media"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-gold hover:text-gold"
              >
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          {NAV.map((item) => (
            <div key={item.label}>
              <h4 className="font-serif text-base font-medium text-gold-light">
                <Link to={item.to} className="hover:text-gold transition-colors">
                  {item.label}
                </Link>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {item.columns.flatMap((c) => c.links).slice(0, 6).map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm font-light text-white/55 transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container-wide flex flex-col gap-3 py-6 text-xs text-white/45 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {BRAND.domain} · An independent visitor guide.</p>
        <p className="max-w-xl md:text-right">
          Not affiliated with the official Parco archeologico del Colosseo. Booking links lead to
          our partner GetYourGuide; we may earn a commission at no extra cost to you.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
